module.exports = __webpack_public_path__ + "img/story-21-4.jpg";